const DynamicReviewTable = ({ title, columns, rows }) => {
  return (
    <div className="mt-10">
      <h3 className="font-bold">{title}</h3>
      <table className="w-full border rounded-md mt-7">
        <thead className="bg-gray-50">
          <tr>
            {columns.map((col, index) => (
              <th key={index} className="px-4 py-3 text-left capitalize">
                {col.column}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {rows && rows.length > 0 ? (
            rows.map((row, index) => (
              <tr key={row.id || index} className="border-t">
                {columns.map((col, colIndex) => {
                  const field = col.value;

                  if (colIndex === 0) {
                    return (
                      <td key={colIndex} className="px-4 py-3">
                        {index + 1}
                      </td>
                    );
                  }

                  if (col?.is_array) {
                    const items = row[field];
                    return (
                      <td
                        key={colIndex}
                        className="px-4 py-3 flex flex-wrap gap-2"
                      >
                        {Array.isArray(items) && items.length > 0
                          ? items.map((item, idx) => {
                              const label =
                                item?.attachment_name || item?.name || item;
                              const url = item?.attachment_url || item?.url;

                              return url ? (
                                <a
                                  key={idx}
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="px-2 py-1 rounded bg-purple-100 text-purple-700 text-xs font-medium hover:underline whitespace-nowrap"
                                >
                                  {label}
                                </a>
                              ) : (
                                <span
                                  key={idx}
                                  className="px-2 py-1 rounded bg-gray-200 text-gray-700 text-xs font-medium whitespace-nowrap"
                                >
                                  {label}
                                </span>
                              );
                            })
                          : "-"}
                      </td>
                    );
                  }

                  if (col?.is_upload) {
                    const url = row[field];
                    return (
                      <td key={colIndex} className="px-4 py-3">
                        {url ? (
                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-2 py-1 rounded bg-blue-100 text-blue-700 text-sm font-medium hover:underline"
                          >
                            View Document
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </td>
                    );
                  }

                  if (col?.is_date) {
                    const dateValue = row[field];
                    if (!dateValue) {
                      return (
                        <td key={colIndex} className="px-4 py-3">
                          -
                        </td>
                      );
                    }

                    const formattedDate = new Date(dateValue)
                      .toLocaleDateString("en-GB")
                      .replace(/\//g, " - ");

                    return (
                      <td key={colIndex} className="px-4 py-3">
                        {formattedDate}
                      </td>
                    );
                  }

                  return (
                    <td key={colIndex} className="px-4 py-3">
                      {row[field] ? row[field] : "-"}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={columns.length}
                className="text-center py-3 text-muted-foreground"
              >
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DynamicReviewTable;
